import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  errors: string[];
  title: string;
  /** Optional severity — reserved for future icon / colour differentiation. */
  type?: 'error' | 'warning' | 'info';
}

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  standalone: false
})
export class ErrorDialogComponent {
  seeMore = false;
  readonly maxVisible = 5;

  constructor(@Inject(MAT_DIALOG_DATA) public readonly data: DialogData) {}

  get visibleErrors(): string[] {
    return this.seeMore
      ? this.data.errors
      : this.data.errors.slice(0, this.maxVisible);
  }

  get hasMore(): boolean {
    return this.data.errors.length > this.maxVisible;
  }

  get remainingCount(): number {
    return this.data.errors.length - this.maxVisible;
  }

  get toggleLabel(): string {
    return this.seeMore ? 'Show less' : `+${this.remainingCount} more`;
  }
}
